import { render } from "./TotalShoppingForYearReportGrapics.vue?vue&type=template&id=2e781732&scoped=true"
import script from "./TotalShoppingForYearReportGrapics.vue?vue&type=script&lang=js"
export * from "./TotalShoppingForYearReportGrapics.vue?vue&type=script&lang=js"

import "./TotalShoppingForYearReportGrapics.vue?vue&type=style&index=0&id=2e781732&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e781732"]])

export default __exports__